import React, { Component } from 'react';
import logo from '../images/new_logo.svg';

export default class Carousel extends React.Component {
  constructor(props) {
    super(props);
    let items = this.props.items || []
    console.log('items', items)
    let currentItemView = items[0];

    console.log('currentItemView', currentItemView)

    this.state = {
      items: items,
      currentItemView: currentItemView,
      currentItem: 0,
      delay: (Math.random() * 800)
    }

    this.carouselChange = this.carouselChange.bind(this);
    this.changeCarouselToPoint = this.changeCarouselToPoint.bind(this);
    this.changeCarousel = this.changeCarousel.bind(this);
  }

  addDefaultSrc(ev) {
    ev.target.src = logo;
  }

  componentDidMount() {
    setInterval(() => {
      this.carouselChange();
    }, (10000 + this.state.delay));
  }

  carouselChange() {
    let itemToShow = this.state.currentItem + 1 > this.state.items.length ? 0 : this.state.currentItem + 1;
    let newItem = this.state.items[itemToShow];

    if (newItem === undefined) {
      newItem = this.state.items[0];
      itemToShow = 0;
    }

    this.setState({
      currentItem: itemToShow,
      currentItemView: newItem
    })
  }

  changeCarouselToPoint(number) {
    let newItem = this.state.items[number];

    if (newItem === undefined) {
      newItem = this.state.items[0];
      number = 0;
    }
    this.setState({
      currentItem: number,
      currentItemView: newItem
    });
  }

  changeCarousel(direction) {
    const currentItem = this.state.currentItemView.Image
    const currentItemIndex = this.state.items.findIndex((item) => {
      return item.Image === currentItem
    })

    let newIndex = currentItemIndex + 1

    if (direction === "left") {
      newIndex = currentItemIndex - 1
    }

    if (newIndex < 0) {
      let length = this.state.items.length;
      newIndex = length + newIndex
    }


    let newItem = this.state.items[newIndex];

    if (newItem === undefined) {
      newItem = this.state.items[0];
      newIndex = 0;
    }

    this.setState({
      currentItem: newIndex,
      currentItemView: newItem
    });
  }

  render() {
    let classNames = "section carousel split";
    if (this.props.inverted) {
      classNames = `${classNames} reversed-split`;
    }
    let hideArrows = this.props.hideArrows || false;
    let currentImage = this.state.currentItemView ? this.state.currentItemView.Image : logo
    currentImage = currentImage.replace("-dev", "-prod")

    return (
      <div id={this.props.id} className={classNames}>
        <div className="content">
          {currentImage &&
            <img className="current-image-selected" onError={this.addDefaultSrc} src={currentImage}/>
          }

          <div className="dots">
            {this.state.items.map((item, index) =>
              <div onClick={() => this.changeCarouselToPoint(index)} className={this.state.currentItem === index ? 'selected dot' : 'not-selected dot'} key={this.props.type+'-'+index}></div>
            )}
          </div>

          <div className="gallery">
            {this.state.items.map((image, index) =>
              <img onClick={(e) => { this.changeCarouselToPoint(index) }} onError={this.addDefaultSrc} src={image.Image} key={"p-image" + index} className="small-img"/>
            )}
          </div>
        </div>
      </div>
    )
  }
}
